module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_data01-sp-c8203d38af149b88bd50e15f7764b4cb.png";